export const CommonDropdownParams = {
  DropdownDefinitions: 0,
  PaymentType: 1,
  TransactionPurpose: 2,
  RoutingPreference: 3,
  SourceOfFunds: 4,
  Relationship: 5,
  PreferredDeliveryType: 6,
  NationalIdType: 7,
  NationalIdIssuingCountry: 8,
  Gender: 9,
  Occupation: 10,
  BankAccountType: 11,
  BusinessType: 12,
  CompanyType: 13,
  NatureOfBusiness: 14,
  CountryFromCountryMaster: 15,
  ProfileStatus:16,
  RegisterReason: 17
};
